import { animateScroll } from "./modules/animateScroll"

export function smoothScrollTo({ id, ref = null, duration = 350 }) {
    // the position of the scroll bar before the user clicks the button
    const initialPosition = window.scrollY

    // if the reference is id
    if (id) {
        const element = document.getElementById(id)

        if (!element) {
            // log error if the reference passed is invalid
            logError()
            return
        }

        animateScroll({
            // target position is the elements offsetTop
            targetPosition: getElementPosition(element),
            initialPosition,
            duration
        })
    }
}